import React from "react";

const Loading = ({
  text = "Loading...",
  fullHeight = false,
  minHeight,
  className,
  spinnerClassName,
}) => {
  const containerClasses = [
    "loading-container",
    fullHeight ? "loading-container--full" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const spinnerClasses = ["spinner loading-spinner", spinnerClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={containerClasses}
      style={{ minHeight }}
      role="status"
      aria-live="polite"
    >
      <div className={spinnerClasses} />
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default Loading;
